export default function DispositionView(props: any) {
    const stateList = [
        { label: 'AL', value: '', name: 'alStateDisposition' },
        { label: 'AK', value: '', name: 'akStateDisposition' },
        { label: 'AZ', value: '', name: 'azStateDisposition' },
        { label: 'AR', value: '', name: 'arStateDisposition' },
        { label: 'CA', value: '', name: 'caStateDisposition' },
        { label: 'CO', value: '', name: 'coStateDisposition' },
        { label: 'CT', value: '', name: 'ctStateDisposition' },
        { label: 'DE', value: '', name: 'deStateDisposition' },
        { label: 'FL', value: '', name: 'flStateDisposition' },
        { label: 'GA', value: '', name: 'gaStateDisposition' },
        { label: 'HI', value: '', name: 'hiStateDisposition' },
        { label: 'ID', value: '', name: 'idStateDisposition' },
        { label: 'IL', value: '', name: 'ilStateDisposition' },
        { label: 'IN', value: '', name: 'inStateDisposition' },
        { label: 'IA', value: '', name: 'iaStateDisposition' },
        { label: 'KS', value: '', name: 'ksStateDisposition' },
        { label: 'KY', value: '', name: 'kyStateDisposition' },
        { label: 'LA', value: '', name: 'laStateDisposition' },
        { label: 'ME', value: '', name: 'meStateDisposition' },
        { label: 'MD', value: '', name: 'mdStateDisposition' },
        { label: 'MA', value: '', name: 'maStateDisposition' },
        { label: 'MI', value: '', name: 'miStateDisposition' },
        { label: 'MN', value: '', name: 'mnStateDisposition' },
        { label: 'MS', value: '', name: 'msStateDisposition' },
        { label: 'MO', value: '', name: 'moStateDisposition' },
        { label: 'MT', value: '', name: 'mtStateDisposition' },
        { label: 'NE', value: '', name: 'neStateDisposition' },
        { label: 'NV', value: '', name: 'nvStateDisposition' },
        { label: 'NH', value: '', name: 'nhStateDisposition' },
        { label: 'NJ', value: '', name: 'njStateDisposition' },
        { label: 'NM', value: '', name: 'nmStateDisposition' },
        { label: 'NY', value: '', name: 'nyStateDisposition' },
        { label: 'NC', value: '', name: 'ncStateDisposition' },
        { label: 'ND', value: '', name: 'ndStateDisposition' },
        { label: 'OH', value: '', name: 'ohStateDisposition' },
        { label: 'OK', value: '', name: 'okStateDisposition' },
        { label: 'OR', value: '', name: 'orStateDisposition' },
        { label: 'PA', value: '', name: 'paStateDisposition' },
        { label: 'RI', value: '', name: 'riStateDisposition' },
        { label: 'SC', value: '', name: 'scStateDisposition' },
        { label: 'SD', value: '', name: 'sdStateDisposition' },
        { label: 'TN', value: '', name: 'tnStateDisposition' },
        { label: 'TX', value: '', name: 'txStateDisposition' },
        { label: 'UT', value: '', name: 'utStateDisposition' },
        { label: 'VT', value: '', name: 'vtStateDisposition' },
        { label: 'VA', value: '', name: 'vaStateDisposition' },
        { label: 'WA', value: '', name: 'waStateDisposition' },
        { label: 'WV', value: '', name: 'wvStateDisposition' },
        { label: 'WI', value: '', name: 'wiStateDisposition' },
        { label: 'WY', value: '', name: 'wyStateDisposition' },
        { label: 'DC', value: '', name: 'dcStateDisposition' },
        { label: 'PR', value: '', name: 'prStateDisposition' },
    ];

    const handleChange = (e: any, name: any) => {
        props.setRowInfo([
            {
                ...props.rowInfo,
                itemHazardousDetails: {
                    ...props.rowInfo?.itemHazardousDetails,
                    [name]: e.target.value,
                },
            },
        ]);
    };

    return (
        <>
            <div className="row ml-0 mr-0 mb-30 modal-title-header">
                <span className="tabNameForAddScreen">Sub-Dispositions</span>
            </div>

            <div className="row" style={{ marginBottom: 15 }}>
                {stateList.map((item, index) => (
                    <div
                        className="col-sm-2"
                        key={index}
                        style={{ marginBottom: 10 }}
                    >
                        <span
                            className="lblClass"
                            style={{ textAlign: 'left', width: '100%' }}
                        >
                            {item.label}
                        </span>
                        <input
                            onInput={(e: any) => handleChange(e, item.name)}
                            name={item.name}
                            value={
                                props.rowInfo?.itemHazardousDetails?.[
                                    item.name
                                ] || ''
                            }
                            // placeholder="Value"
                            type="text"
                            className="form-control"
                        />
                    </div>
                ))}
            </div>
        </>
    );
}
